module.exports = "/_next/static/images/ImproveYourAds@2x-01654d54506d811da260634598c99356.png";